module.exports = __webpack_public_path__ + "static/media/dashboard_content.286e32d0.png";